import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instance23xvvm1c2fncv as EmptyIterator_instance } from './CollectionsKt.mjs';
import {
  iterator3f5i676wpaa3g as iterator,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instanceovl8he3jiijf as Companion_instance,
} from './AbstractList.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().a1(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.n1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda_0(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.ho_1 = this$0;
        super($box);
        this.fo_1 = this$0.lo_1;
        this.go_1 = this$0.ko_1;
      }
      yj() {
        if (this.fo_1 === 0) {
          this.ak();
        } else {
          var tmp = this.ho_1.io_1[this.go_1];
          this.zj((tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE());
          var tmp_0 = this;
          var tmp0 = this.ho_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp_0.go_1 = (this.go_1 + 1 | 0) % tmp0.jo_1 | 0;
          this.fo_1 = this.fo_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      static mo(buffer, filledSize) {
        var $this = this.ti();
        $this.io_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.io_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.io_1.length;
          throw IllegalArgumentException().a1(toString(message_0));
        }
        $this.jo_1 = $this.io_1.length;
        $this.ko_1 = 0;
        $this.lo_1 = filledSize;
        return $this;
      }
      static no(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.mo(tmp$ret$0, 0);
      }
      p1() {
        return this.lo_1;
      }
      q1(index) {
        Companion_instance.f7(index, this.lo_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.ko_1 + index | 0) % this.jo_1 | 0;
        var tmp = this.io_1[tmp$ret$0];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      oo() {
        return this.lo_1 === this.jo_1;
      }
      m1() {
        return new (RingBuffer$iterator$1())(this);
      }
      dl(array) {
        var tmp;
        if (array.length < this.lo_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.lo_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.lo_1;
        var widx = 0;
        var idx = this.ko_1;
        while (widx < size && idx < this.jo_1) {
          var tmp_0 = widx;
          var tmp_1 = this.io_1[idx];
          result[tmp_0] = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          var tmp_2 = widx;
          var tmp_3 = this.io_1[idx];
          result[tmp_2] = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_4 = terminateCollectionToArray(size, result);
        return isArray(tmp_4) ? tmp_4 : THROW_CCE();
      }
      e8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.lo_1;
        var tmp$ret$0 = Array(size);
        return this.dl(tmp$ret$0);
      }
      toArray() {
        return this.e8();
      }
      po(maxCapacity) {
        var newCapacity = coerceAtMost((this.jo_1 + (this.jo_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.ko_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.io_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.dl(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().mo(newBuffer, this.lo_1);
      }
      qo(element) {
        if (this.oo()) {
          throw IllegalStateException().o4('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.ko_1 + this.lo_1 | 0) % this.jo_1 | 0;
        this.io_1[tmp$ret$0] = element;
        this.lo_1 = this.lo_1 + 1 | 0;
      }
      ro(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.lo_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.lo_1;
          throw IllegalArgumentException().a1(toString(message_0));
        }
        if (n > 0) {
          var start = this.ko_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.jo_1 | 0;
          if (start > end) {
            fill(this.io_1, null, start, this.jo_1);
            fill(this.io_1, null, 0, end);
          } else {
            fill(this.io_1, null, start, end);
          }
          this.ko_1 = end;
          this.lo_1 = this.lo_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [AbstractList(), RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var bufferInitialCapacity = coerceAtMost($this.so_1, 1024);
  var gap = $this.to_1 - $this.so_1 | 0;
  if (gap >= 0) {
    var buffer = ArrayList().u(bufferInitialCapacity);
    var skip = 0;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = $this.uo_1;
    $l$loop: while (_iterator__ex2g4s.n1()) {
      var e = _iterator__ex2g4s.o1();
      if (skip > 0) {
        skip = skip - 1 | 0;
        continue $l$loop;
      }
      buffer.v(e);
      if (buffer.p1() === $this.so_1) {
        var tmp = $this$iterator.q2(buffer, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if ($this.vo_1) {
          buffer.v3();
        } else
          buffer = ArrayList().u($this.so_1);
        skip = gap;
      }
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!buffer.i1()) {
      if ($this.wo_1 || buffer.p1() === $this.so_1) {
        var tmp_0 = $this$iterator.q2(buffer, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
      }
    }
  } else {
    var buffer_0 = RingBuffer().no(bufferInitialCapacity);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = $this.uo_1;
    $l$loop_0: while (_iterator__ex2g4s_0.n1()) {
      var e_0 = _iterator__ex2g4s_0.o1();
      buffer_0.qo(e_0);
      if (buffer_0.oo()) {
        if (buffer_0.lo_1 < $this.so_1) {
          buffer_0 = buffer_0.po($this.so_1);
          continue $l$loop_0;
        }
        var tmp_1 = $this$iterator.q2($this.vo_1 ? buffer_0 : ArrayList().b1(buffer_0), $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        buffer_0.ro($this.to_1);
      }
    }
    if ($this.wo_1) {
      while (buffer_0.lo_1 > $this.to_1) {
        var tmp_2 = $this$iterator.q2($this.vo_1 ? buffer_0 : ArrayList().b1(buffer_0), $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        buffer_0.ro($this.to_1);
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer_0.i1()) {
        var tmp_3 = $this$iterator.q2(buffer_0, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
      }
    }
  }
  return Unit_instance;
}
var windowedIterator$slambdaClass;
function windowedIterator$slambda() {
  if (windowedIterator$slambdaClass === VOID) {
    class $ {
      constructor($size, $step, $iterator, $reuseBuffer, $partialWindows) {
        this.so_1 = $size;
        this.to_1 = $step;
        this.uo_1 = $iterator;
        this.vo_1 = $reuseBuffer;
        this.wo_1 = $partialWindows;
      }
      xo($this$iterator, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
      }
      s2(p1, $completion) {
        return this.xo(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    windowedIterator$slambdaClass = $;
  }
  return windowedIterator$slambdaClass;
}
function windowedIterator$slambda_0($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  var i = new (windowedIterator$slambda())($size, $step, $iterator, $reuseBuffer, $partialWindows);
  var l = ($this$iterator, $completion) => i.xo($this$iterator, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
